'use strict';

(function() {
	angular.module('dat.shared-components.common')
		.factory('BaseHttpService', baseHttpService);

	baseHttpService.$inject = ['$http'];

	function baseHttpService($http) {
		return {
			post: post,
			get: get,
			get2: get2,
			put: put,
			'delete': deleteFunc
		};

		function post(path, model, successFunc, errorFunc) {
			return execute($http.post, path, model, successFunc, errorFunc);
		}

		function put(path, model, successFunc, errorFunc) {
			return execute($http.put, path, model, successFunc, errorFunc);
		}

		function get(path, successFunc, errorFunc) {
			return get2(path, null, successFunc, errorFunc);
		}

		function deleteFunc(path, id, successFunc, errorFunc) {
			var config = getBypassErrorConfig(errorFunc);

			return $http.delete(path + '/' + id, config)
				.success(function (data, status, headers, config) {
					handleSuccess(successFunc, data, status, headers, config);
				})
				.error(function (data, status, headers, config) {
					handleError(errorFunc, data, status, headers, config);
				});
		}

		function get2(path, model, successFunc, errorFunc) {
			var config = getBypassErrorConfig(errorFunc);
			if (model) {
				config.params = model;
			}

			return $http.get(path, config)
				.success(function(data, status, headers, config) {
					handleSuccess(successFunc, data, status, headers, config);
				})
				.error(function(data, status, headers, config) {
					handleError(errorFunc, data, status, headers, config);
				});
		}

		function execute(func, path, model, successFunc, errorFunc) {
			var config = getBypassErrorConfig(errorFunc);

			return func(path, model, config)
				.success(function(data, status, headers, config) {
					handleSuccess(successFunc, data, status, headers, config);
				})
				.error(function(data, status, headers, config) {
					handleError(errorFunc, data, status, headers, config);
				});
		}

		function getBypassErrorConfig(error) {
			return error ? { bypassErrorsInterceptor: true } : {};
		}

		function handleSuccess(successFunc, data, status, headers, config) {
			if (successFunc) {
				successFunc(data, status, headers, config);
			}
		}

		function handleError(errorFunc, data, status, headers, config) {
			if (errorFunc) {
				errorFunc(data, status, headers, config);
			}
		}
	}
})();
